"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityNurseDefaultRatesDetailsDto = instanceOfFacilityNurseDefaultRatesDetailsDto;
exports.FacilityNurseDefaultRatesDetailsDtoFromJSON = FacilityNurseDefaultRatesDetailsDtoFromJSON;
exports.FacilityNurseDefaultRatesDetailsDtoFromJSONTyped = FacilityNurseDefaultRatesDetailsDtoFromJSONTyped;
exports.FacilityNurseDefaultRatesDetailsDtoToJSON = FacilityNurseDefaultRatesDetailsDtoToJSON;
exports.FacilityNurseDefaultRatesDetailsDtoToJSONTyped = FacilityNurseDefaultRatesDetailsDtoToJSONTyped;
/**
 * Check if a given object implements the FacilityNurseDefaultRatesDetailsDto interface.
 */
function instanceOfFacilityNurseDefaultRatesDetailsDto(value) {
    if (!('hourlyRate' in value) || value['hourlyRate'] === undefined)
        return false;
    if (!('onCallRate' in value) || value['onCallRate'] === undefined)
        return false;
    if (!('callbackRate' in value) || value['callbackRate'] === undefined)
        return false;
    if (!('travelStipendEnabled' in value) || value['travelStipendEnabled'] === undefined)
        return false;
    if (!('travelStipendAmount' in value) || value['travelStipendAmount'] === undefined)
        return false;
    if (!('travelStipendMinimumDistance' in value) || value['travelStipendMinimumDistance'] === undefined)
        return false;
    if (!('travelStipendQualified' in value) || value['travelStipendQualified'] === undefined)
        return false;
    return true;
}
function FacilityNurseDefaultRatesDetailsDtoFromJSON(json) {
    return FacilityNurseDefaultRatesDetailsDtoFromJSONTyped(json, false);
}
function FacilityNurseDefaultRatesDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'hourlyRate': json['hourlyRate'],
        'onCallRate': json['onCallRate'],
        'callbackRate': json['callbackRate'],
        'travelStipendEnabled': json['travelStipendEnabled'],
        'travelStipendAmount': json['travelStipendAmount'],
        'travelStipendMinimumDistance': json['travelStipendMinimumDistance'],
        'travelStipendQualified': json['travelStipendQualified'],
    };
}
function FacilityNurseDefaultRatesDetailsDtoToJSON(json) {
    return FacilityNurseDefaultRatesDetailsDtoToJSONTyped(json, false);
}
function FacilityNurseDefaultRatesDetailsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'hourlyRate': value['hourlyRate'],
        'onCallRate': value['onCallRate'],
        'callbackRate': value['callbackRate'],
        'travelStipendEnabled': value['travelStipendEnabled'],
        'travelStipendAmount': value['travelStipendAmount'],
        'travelStipendMinimumDistance': value['travelStipendMinimumDistance'],
        'travelStipendQualified': value['travelStipendQualified'],
    };
}
//# sourceMappingURL=FacilityNurseDefaultRatesDetailsDto.js.map